/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box } from "@nordcloud/gnui";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { ResourcesTable } from "./components";

export function ResourcesPageV2() {
  const breadcrumbsLabels = [
    { label: "Dashboard", uri: "/" },
    { label: "Resources V2", uri: ROUTES.resourcesV2.index },
  ];

  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Resources v2"
            customBreadcrumbs={breadcrumbsLabels}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <ResourcesTable />
          </Box>
        </Col>
      </Row>
    </>
  );
}
